import { Routes, Route } from "react-router-dom";
import Home from "../components/pages/website/pages/Home";
import Howitworks from "../components/pages/website/pages/Howitworks";
import Campaigns from "../components/pages/website/pages/Campaigns";
import Impact from "../components/pages/website/pages/Impact";
import Contact from "../components/pages/website/pages/Contact";
import CampaignDetails from "../components/pages/website/pages/CampaignDetails"
import PrivacyPolicy from "../components/pages/website/pages/Page components/Policies/PrivacyPolicies";
import TermsOfUse from "../components/pages/website/pages/Page components/Policies/Termsofuse";
import FundraisingTipsPage from "../components/pages/website/pages/Page components/FundraisingTips";
import PaymentSuccess from '../components/Reusable/PaymentSuccess'
import PayPalSuccess from "../components/Reusable/PaypalPage";
import EmbedDonatePage from "../components/pages/website/pages/EmbedDonatePage";
import MembershipForm from "../components/pages/website/pages/MembershipForm";
import MembershipSuccess from "../components/pages/website/pages/MembershipSuccess";

function WebsiteRoutes() {
  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="/campaigns" element={<Campaigns />} />
      <Route path="/how-it-works" element={<Howitworks />} />
      <Route path="/impact" element={<Impact />} />
      <Route path="/Contact-us" element={<Contact />} />
      <Route path="/campaigns/:id" element={<CampaignDetails />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-use" element={<TermsOfUse />} />
      <Route path="/fundraising-tips" element={<FundraisingTipsPage />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/paypal/success" element={<PayPalSuccess />} />
      <Route path="/embed/donate" element={<EmbedDonatePage />} />
      <Route path="/membership/:slug" element={<MembershipForm />} />
      <Route path="/membership-success" element={<MembershipSuccess />} />








    </Routes>
  );
}

export default WebsiteRoutes;
